/* global $ */
/* global _mtm */

{
let _mainInitialized = false;
const _mainInit = function () {
  if (_mainInitialized) return;
  _mainInitialized = true;

  //Tooltips
  bootstrap.Tooltip.Default.allowList.font = ['face'];
	document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => bootstrap.Tooltip.getOrCreateInstance(el));

	//Gallery Slider
	if( $('#main-carousel').length && $('#thumbnail-carousel').length ) {
    // Customer wants just to show the first 10 assets
    $('#main-carousel .splide__list li').slice(15).remove();
    $('#thumbnail-carousel .splide__list li').slice(15).remove();

		var main = new Splide( '#main-carousel', {
		  type      : 'fade',
		  rewind    : true,
		  pagination: false,
		  arrows    : false,
		  drag		: false,
      lazyLoad: 'nearby',
		  dragAngleThreshold: 0
		} );

		var thumbnails = new Splide( '#thumbnail-carousel', {
		  role: 'thumbnails',
		  fixedWidth  : 115,
		  fixedHeight : 115,
		  gap         : 12,
		  rewind      : false,
		  pagination  : false,
		  isNavigation: true,
		  breakpoints : {
			768: {
			  fixedWidth : 56,
			  fixedHeight: 56,
			},
		  },
		} );

		main.sync( thumbnails );
		main.mount();
		thumbnails.mount();

    $(document).ready(function() {
      $('.product-gallery-wrapper').css('height', 'auto');
    });
	}

	//Product Comparison
	if( $('.table--related-products').length ) {
		const fixColumns = function() {
			$('.table--related-products').each( function () {
				const bigTableCells = $(this).find('.table-wrapper table tr:not(.mobile-titles)');
				const smallTableCells = $(this).find('.pseudo-table .pseudo-title');

				bigTableCells.each( function (index) {
					if( smallTableCells[index] ) {
						$(smallTableCells[index]).css('height', 'auto');
						$(this).css('height', 'auto');
						if( $(window).width() >= 993 ) {
							var maxH = Math.max( $(smallTableCells[index]).outerHeight(), $(this).outerHeight() ) + 2;
							$(smallTableCells[index]).css('height', maxH);
							$(this).css('height', maxH);
						}
					}
				});


				//desktop
				if( $(window).width() >= 993 ) {
					//and there's no scroll
					var containerWidth = $(this).find('.table-wrapper').width() - 40;
					var tableWidth = $(this).find('.table-wrapper table').width();
					if( containerWidth >= tableWidth ) {
						var maxH = 0;
						$(this).find('.pseudo-table .pseudo-title span').each( function (index) {
							if(index) {
								maxH = Math.max( $(this).outerHeight(), maxH );
							}
						});

						if( maxH > 40 ) {
							var newW = $('.table--related-products .pseudo-table').width() + 10;
							$('.table--related-products').css('--fakeCellWidth',  newW+'px' );
							setTimeout(fixColumns);
						} else {
							$('.table--related-products').removeClass('loading');
						}
					} else {
						$('.table--related-products').removeClass('loading');
					}
				} else {
					$('.table--related-products').removeClass('loading');
				}
			});
		}
		fixColumns();
		$(window).resize(fixColumns);

		const observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if( mutation.target.classList.contains('stock-label') &&  $('.table--related-products').length) {
					fixColumns();
				}
			});
		});

		const config = {
			attributes: true,
			childList: true,
			subtree: true
		};

		$('.product-tile').each( function () {
			observer.observe(this, config);
		});

		$.fn.hscrollarrows = function(){
			return this.each(function() {

			  var navNext = $('.table-arrow.arrow-right');
			  var navPrev = $('.table-arrow.arrow-left');
			  var scrollTime = null;
			  var resizeTime = null;
			  var scrolling = false;

			  var elm_w = 0;
			  var elem_data_w = 0;
			  var max_scroll = 0;
			  var inc_scroll = 0;

			  var calcData = function(){
				elm_w = elem.width();
				elem_data_w = elem_data.width();
				max_scroll = elem_data_w - elm_w;
				inc_scroll = elm_w * 0.3; // 20%
			  }

			  var revalidate = function(){
				calcData();
				stateNavs();
			  }

			  var run = function(){
				calcData();
				setupNavs();
			  }

			  var setupNavs = function(){

				//elem.parent().prepend( navNext );
				//elem.parent().prepend( navPrev );
				navNext.on('click', next);
				navPrev.on('click', prev);
				stateNavs();

				$(elem).scroll(function() {
					if( !scrolling ){
					  clearTimeout( scrollTime );
					  scrollTime = setTimeout(function() {
						  stateNavs();
						}, 250);
					}
				});

				$(window).resize(function(){
				  clearTimeout( resizeTime );
				  resizeTime = setTimeout(function() {
					revalidate();
				  }, 250);
				});
			  }

			  var stateNavs = function(){
				var current_scroll = elem.scrollLeft();
				if( current_scroll < max_scroll ){
				  navNext.removeClass('hide');
				}else{
				  navNext.addClass('hide');
				}
				if( current_scroll > 0 ){
				  navPrev.removeClass('hide');
				}else{
				  navPrev.addClass('hide');
				}
				scrolling = false;

				if(navNext.hasClass('hide')) {
					navNext.hide();
				} else {
					navNext.show();
				}

				if(navPrev.hasClass('hide')) {
					navPrev.hide();
				} else {
					navPrev.show();
				}
			  }

			  var next = function(){
				var current_scroll = elem.scrollLeft();
				if( current_scroll < max_scroll ){
				  scrolling = true;
				  elem.stop().animate({
					scrollLeft: ( current_scroll + inc_scroll )
				  }, stateNavs);
				}
			  }

			  var prev = function(){
				var current_scroll = elem.scrollLeft();
				if( current_scroll > 0 ){
				  scrolling = true;
				  elem.stop().animate({
					scrollLeft: ( current_scroll - inc_scroll )
				  }, stateNavs);
				}
			  }

			  var elem = $( this );
			  var elem_data = $(':first-child', elem);

			  run();

			});
		  }

		  $(document).ready(function(){
			$('.jquery-horizontal-scroll').hscrollarrows();
		  });
	}

};
const _mainFallback = setTimeout(function () {
  console.warn('[Hazet] Main (content): fallback init (HazetStartContent not received within 5s)');
  _mainInit();
}, 5000);
document.addEventListener('HazetStartContent', function () {
  clearTimeout(_mainFallback);
  _mainInit();
});
}

//Element Navigation Scroll Sticky

function scroll_navigation() {
	if( $('.frame-type-menu_section').length ) {
		var topHeight = $('#top-header').outerHeight() + $('#page-header').outerHeight() + $('.bg-lighter').outerHeight();

		$('.frame-type-menu_section').css('top', topHeight);
	}
}

$(function() {
  $(window).scroll(scroll_navigation);
  	scroll_navigation();
  }
);

$(document).on('click', '.frame-type-menu_section a', function (e) {
	e.preventDefault();
	var dest = $(this).attr('href');
	$('html,body').animate({
	  scrollTop: $("#" + dest.substring(dest.indexOf('#') +1)).offset().top-190
	}, 'slow');
  });

$('#mainnav-toggler').on('click', function() {
	$('body').toggleClass('overflow-hidden');
	let isMenuOpened = $(this).attr('aria-expanded');
	if(isMenuOpened === 'true') {
		let cloneBar = $('.floating-bar').clone();
		$('#mainnavigation .floating-bar').remove();
		$('#mainnavigation').append(cloneBar);
	}
	$('.search-flyout').hide();
});

var handleBodyScroll = function() {
	const heroComponent = $('#page-content>.images:first-child');
	const threshold = heroComponent.length ? ((heroComponent.outerHeight() + heroComponent.offset().top) - ( $('#page-header').outerHeight() + $('#page-header').offset().top - $(window).scrollTop() )) : 1;
	// console.log("Threshold: " + threshold);
	// console.log($(window).scrollTop());
	if( $(window).scrollTop() >= threshold ) {
		$('body').addClass('scrolled');
	} else {
		$('body').removeClass('scrolled');
	}
}

handleBodyScroll();
$(window).scroll(handleBodyScroll);

// select2-fix for newer jquery-version not focusing search-field
$(document).on('select2:open', () => {
  document.querySelector('.select2-container--open .select2-search__field').focus();
});

$('.lightboxhz').on('click', function(e) {
	e.preventDefault();
	$('.product-gallery-wrapper').addClass('fullscreen');
	MagicZoom.refresh();
});

$(document).keyup(function(e) {
	if (e.which == 27) $('.close-lightboxhz').click();
});

$('.close-lightboxhz').on('click', function () {
	$('.product-gallery-wrapper').removeClass('fullscreen');
});

$('.expand-lightboxhz').on('click', function () {
	$('.product-gallery-wrapper').addClass('fullscreen');
	// console.log('destroyZoom');
	MagicZoom.stop('zoom');
});

//Add style to Hero title
let handleHeroContent = function() {
	if($('.hero-title').length) {
		var linesCount = 0;
		$('.hero-title p').each(function(){
			linesCount++;
			$(this).addClass('highlight');
			$(this).append('<span></span>');
		});
		if(linesCount < 3) {
			// $('.hero-title').addClass('center');
		}

		// var maxHeight = $('.hero-wrapper').height();
		// var heroSectionHeight = $('.images').height();


		// if(parseInt(heroSectionHeight) - 90 < maxHeight ) {
		// 	$('.hero-teaser').hide();
		// } else {
		// 	$('.hero-teaser').show();
		// }
	}
}

handleHeroContent();
$(window).on('resize', handleHeroContent);

//
//NAV
//Branchen & Katalog (no hanburger menu)
//
{
let _navInitialized = false;
const _navInit = function () {
  if (_navInitialized) return;
  _navInitialized = true;
  // Signal the early inline nav handler (headerData in page-setup.typoscript) to
  // step aside — from here the full jQuery nav logic (with animations) owns the
  // mega-menu open/close.
  window.__hazetNavReady = true;
  $('.navbar-nav > .nav-item > .dropdown-toggle').on('click', function(e) {
	if($(window).width() > 992){
		e.preventDefault();


		$(this).parent().toggleClass('slideDown');
		if( $(this).parent().hasClass('slideDown') ) {
			$('.navbar-nav > .nav-item > .dropdown-toggle').not(this).attr('aria-expanded', 'false');
			$(this).attr('aria-expanded', 'true');

			if( $(this).parent().find('.two-cols-wrapper').length ) {
				$('.navbar-nav > .nav-item').not($(this).parent())
				.removeClass('hover')
				.removeClass('slideDown')
				.children('.dropdown-menu')
				.hide();

				$(this)
				.parent()
				.addClass('hover')
				.find('.two-cols-wrapper')
				.first()
				.slideDown({
					start: function () {
					  $(this).parent().find('.two-cols-wrapper').css({
						display: "flex"
					  })
					  $(this).parent().find('.two-cols-wrapper > .dropdown-menu').css({
						display: "block"
					  })
					}
				  }, 400);
				handleMenuSize();
			} else {
				$('.navbar-nav > .nav-item').not($(this).parent())
				.removeClass('hover')
				.removeClass('slideDown')
				.find('.two-cols-wrapper')
				.hide();

				$('.navbar-nav > .nav-item').not($(this).parent())
				.children('.dropdown-menu')
				.hide();

				$(this)
				.parent()
				.addClass('hover')
				.find('.dropdown-menu')
				.first()
				.slideDown(400);
				handleMenuSize();
			}

		} else {
			$(this).attr('aria-expanded', 'false');
			if( $(this).parent().find('.two-cols-wrapper').length ) {
				$(this)
				.parent()
				.find('.two-cols-wrapper')
				.first()
				.slideUp(400, function() {
					$(this).parent().removeClass('hover');
				});
				handleMenuSize();
			} else {
				$(this)
				.parent()
				.find('.dropdown-menu')
				.first()
				.slideUp(400, function() {
					$(this).parent().removeClass('hover');
				});
				handleMenuSize();
			}
		}
	}
});

$(document).keydown(function(e) {
      if (e.keyCode == 27) {
      $('.navbar-nav > .nav-item > .dropdown-toggle').attr('aria-expanded', 'false');
      setTimeout(function () {
        $('.recentsearch-wrapper')
        .fadeOut(200);
        $('.container-modal-recentsearch')
        .fadeOut(200);

        $('.search-flyout.expanded')
        .removeClass('expanded');
      }, 200);

      setTimeout( function () {
        $('.search-flyout .input-group').fadeIn(500);
      }, 400);


          $('.two-cols-wrapper')
        .slideUp(400)
        .parent()
        .removeClass('hover')
        .removeClass('slideDown');

      $('.navbar-nav .dropdown-menu').slideUp(400, function() {
        $(this).parent()
        .removeClass('hover')
        .removeClass('slideDown')
      });
      }
  });

  $(document).on('click', function(event) {
    if (!$(event.target).closest('.navbar-nav > .nav-item').length) {
      $('.navbar-nav > .nav-item > .dropdown-toggle').attr('aria-expanded', 'false');
      $('.two-cols-wrapper')
    .slideUp(400)
    .parent()
    .removeClass('hover')
    .removeClass('slideDown')
    $('.navbar-nav .dropdown-menu')
    .slideUp(400, function() {
      $(this).parent()
      .removeClass('hover')
      .removeClass('slideDown')
    });
    }

    if ( event.target.className == 'container-modal-recentsearch' ) {

    // $('.main-input-group').html($('.recentsearch-wrapper').find('.input-group').html());
    // $('.recentsearch-wrapper').find('.input-group').html('')

    $('.search-flyout .input-group').fadeOut(100);

    setTimeout(
      function () {
      $('.recentsearch-wrapper')
      .fadeOut(200);
      $('.container-modal-recentsearch')
      .fadeOut(200);

      $('.search-flyout.expanded')
      .removeClass('expanded');

      }, 200);

    setTimeout( function () {
      $('.search-flyout .input-group').fadeIn(500);
    }, 400);

    }

    if ( !$(event.target).closest('.search-filter-wrapper').length && !$(event.target).closest('.open-filters').length ) {


      $('.search-filter-wrapper')
    .fadeOut(300);
    }


  });

  $('.navbar-nav li:nth-child(2) li.has-children').on('click', function(e){
    if($(window).width() > 992){
      // console.log();
      if($(e.target).closest('li').hasClass('has-children') && !$(this).hasClass('menu-item-hovered')) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().find('.menu-item-hovered').removeClass('menu-item-hovered');
        $(this).addClass('menu-item-hovered');
      }
    }
  });

  $('.navbar-nav li:nth-child(1) li.has-children').on('click', function(e){

    if($(window).width() > 992){
      // console.log();

      if($(e.target).closest('li').hasClass('has-children') && !$(e.target).hasClass('.nav-flyout--close') ) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().find('.menu-item-hovered').toggleClass('menu-item-hovered');
        $(this).toggleClass('menu-item-hovered');

        if( $(this).children('.nav-flyout').length ) {
          $('.two-cols-wrapper').addClass('submega-active');
          $(this).children('.nav-flyout').addClass('expanded');
        }
      }
    }
  });
  let handleMenuSize = function(){
    if($(window).width() > 992){
      let firstElWidth = $('.navbar-nav li:nth-child(2).hover .dropdown-menu li').width();
      $('.navbar-nav li:nth-child(2).hover .dropdown-menu li .dropdown-menu').css('width', firstElWidth - 55);
    }
  }
  handleMenuSize();
  $(window).on('resize', handleMenuSize);


  //
  //NAV
  //Hamburger menu visiible
  //

  // $(document).on('click', '.navbar-nav > li > a', function (e) {
  // 	if($(window).width() < 1200){
  // 		const shouldClose = $(this).closest('li').hasClass('hover');
  // 		$('.navbar-nav > li.hover').removeClass('hover');
  // 		if( shouldClose ) {
  // 			$(this).closest('li').removeClass('hover');
  // 		} else {
  // 			$(this).closest('li').addClass('hover');
  // 		}
  // 		e.preventDefault();
  // 		// e.stopPropagation();
  // 	}
  // });

  $(document).on('click', '.navbar-nav li.has-children', function(e){
    if($(window).width() < 993){
      // console.log();
      if($(e.target).closest('li').hasClass('has-children')) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().find('.hover').not($(this)).removeClass('hover');
        $(this).toggleClass('hover');
        // keep the level-1 toggle's aria-expanded in sync on mobile
        $(this).children('.dropdown-toggle').attr('aria-expanded', $(this).hasClass('hover') ? 'true' : 'false');
      }
    }
  });


  //
  //NAV
  //Mobile only
  //
  let handleServicesMenuMobile = function(){
    if($(window).width() < 993){
      $('.navbar-topnavigation .meta-container .meta-menu > li').each(function() {
        if( !$(this).find('.language-selector-menu').length ) {
          $(this).appendTo( $('.navbar-topnavigation #mainnavigation .navbar-nav') ).addClass('nav-item');
        }
      });


      if(  !$('.navbar-topnavigation #mainnavigation').hasClass('mobile-extended') ) {
        let $footerNavigationItems = $('.footer-mobile-nav-source > ul > li');
        if (!$footerNavigationItems.length) {
          $footerNavigationItems = $('.footer-nav > ul > li');
        }
        $footerNavigationItems.each(function() {
          if( !$(this).find('.language-selector-menu').length ) {
            $(this).clone().appendTo( $('.navbar-topnavigation #mainnavigation .navbar-nav') ).addClass('footer-item nav-item');
          }
        });
      }

      $('.navbar-topnavigation #mainnavigation').addClass('mobile-extended');

      $('.navbar-topnavigation #mainnavigation .navbar-nav li > a:not(.nav-link)').addClass('nav-link');

    } else {
      $('.navbar-topnavigation #mainnavigation .navbar-nav > .meta-item').each(function() {
        $(this).removeClass('nav-item').appendTo( $('.navbar-topnavigation .meta-container .meta-menu') );
      });

      $('.navbar-topnavigation #mainnavigation .navbar-nav > .footer-item').each(function() {
        $(this).remove();
      });
    }
    const langMenu = $('.navbar-topnavigation .meta-container .meta-menu > .meta-item .language-selector-menu').closest('.meta-item');
    langMenu.appendTo( $('.navbar-topnavigation .meta-container .meta-menu') );
  }
  handleServicesMenuMobile();
  $(window).on('resize', handleServicesMenuMobile);

  $('.navbar-topnavigation .meta-container .meta-menu > li').each(function() {
    $(this).on('mouseover', function() {
      $('.two-cols-wrapper')
      .slideUp(400)
      .parent()
      .removeClass('hover')
      .removeClass('slideDown')
      $('.navbar-nav .dropdown-menu')
      .slideUp(400, function() {
        $(this).parent()
        .removeClass('hover')
        .removeClass('slideDown')
      });
    })
  });
  //
  //END NAV
  //

  $('.nav-flyout--close').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('.two-cols-wrapper').removeClass('submega-active');
    $('.nav-flyout').removeClass('expanded');
  })
};
const _navFallback = setTimeout(function () {
  console.warn('[Hazet] Main (nav): fallback init (HazetMainMenuReady not received within 5s)');
  _navInit();
}, 5000);
// The nav open/close handlers bind directly to the injected nav DOM, so they
// must run AFTER menu.js has injected the mega-menu. menu.js dispatches
// HazetMainMenuReady at that point (HazetStartContent now fires earlier, so the
// content modules run in parallel with the menu load and must NOT gate the nav).
document.addEventListener('HazetMainMenuReady', function () {
  clearTimeout(_navFallback);
  _navInit();
});
}

//sticky filters in category pages

const handleStickyFilters = function() {
	$('.sticky-filters-spacer').each(function() {
		$(this).css('height', 'auto');
		if ($(window).width() > 768){
			const filterHeight = $(this).closest('.q4u_hazet_products').find('.sticky-filters').height();
			$(this).css('height', Math.max(100, filterHeight) + 'px');
		}
	});

	$('.sticky-side-filters > .row').each(function() {
		$(this).css('left', 'auto');
		$(this).css('width', 'auto');
		$(this).css('--filtersHeight', '0');
		if ($(window).width() > 768){
			var mainFilters = $(this).closest('.q4u_hazet_products').find('.sticky-filters');
			$(this).css('--filtersHeight', (mainFilters.length ? mainFilters.outerHeight().toFixed(0) : 0)+'px');
			$(this).css('left', $(this).closest('.sticky-side-filters').offset().left);
			$(this).css('width', $(this).closest('.sticky-side-filters').outerWidth());

			const footerTop = $('#page-footer').offset().top - $(window).scrollTop();
			const filtersBottom = $(this).offset().top + $(this).outerHeight() - $(window).scrollTop();
			const diff = parseInt(filtersBottom - footerTop);
			let currentMT = parseInt($(this).css('margin-top'));
			if( isNaN(currentMT) ) {
				currentMT = 0;
			}
			if( diff > 0 ) {
				$(this).css('margin-top', (currentMT - diff) + 'px');
			} else {
				if( currentMT < 0 ) {
					$(this).css('margin-top', Math.min(0, currentMT - diff) + 'px');
				}
			}
		} else{
			$(this).css('margin-top', '0px');
		}
	})

	$('.sticky-filters').each(function() {
		if ($(window).width() > 768){
			const footerTop = $('#page-footer').offset().top - $(window).scrollTop();
			const filtersBottom = $(this).offset().top + $(this).outerHeight() - $(window).scrollTop();
			const diff = parseInt(filtersBottom - footerTop);
			let currentMT = parseInt($(this).css('margin-top'));
			if( isNaN(currentMT) ) {
				currentMT = 0;
			}
			if( diff > 0 ) {
				$(this).css('margin-top', (currentMT - diff) + 'px');
			} else {
				if( currentMT < 0 ) {
					$(this).css('margin-top', Math.min(0, currentMT - diff) + 'px');
				}
			}
		} else{
			$(this).css('margin-top', '0px');
		}
	});
}

$(window).resize(handleStickyFilters);
$(window).scroll(handleStickyFilters);

const delayedHandleStickyFilters = function() {
	setTimeout(handleStickyFilters);
}
delayedHandleStickyFilters();

//From ProductComparison.js
$(window)
	.on(
	'change',
	'.product-compare-checkbox',
	delayedHandleStickyFilters
	)
	.on(
	'change',
	'.product-compare-switch',
	delayedHandleStickyFilters
	)
	.on(
	'click',
	'.product-compare-close',
	delayedHandleStickyFilters
	);

$(document).on('click', '.open-filters', function () {
	$('.search-filter-wrapper').fadeIn('300');
});

$(document).on('click', '.close-filters, .close-filters-btn', function () {
	$('.search-filter-wrapper').fadeOut('300');
});

$('.toggle-search').on('click', function () {
	$('.search-flyout').fadeToggle();
});

//Handle Hash scroll

var isScrollingToHash = false;

if( window.location.hash && window.location.hash.search(/web_filter.*faceting/g) === -1 &&  $(window.location.hash).length) {
  hashScroll(window.location.hash);
}

$('a').click(function(e){
	if( $(this).attr('href') && $(this).attr('href').indexOf('#') != -1 ) {
		var hash = $(this).attr('href').substring($(this).attr('href').indexOf('#'));

		if(hash == '#') {
			return;
		}

		if( $(hash).length ) {
			e.preventDefault();
			e.stopPropagation();
			hashScroll(hash);
		}
	}
});

function hashScroll(hash) {
	var topHeight = $('#top-header').outerHeight() + $('#page-header').outerHeight() + $('.bg-lighter').outerHeight();

	isScrollingToHash = true;
	$("html, body").animate({
		scrollTop: $(hash).offset().top - topHeight
	}, 500, function() {
		isScrollingToHash = false;
	});
}


// if( $(".table-wrapper.jquery-horizontal-scroll").length > 0 ) {
// 	var tableOffset = $(".table-wrapper.jquery-horizontal-scroll").offset().top;
// 	var $header = $(".table-wrapper.jquery-horizontal-scroll thead").clone();
// 	var $fixedHeader = $("#header-fixed").append($header);

// 	$(window).bind("scroll", function() {
// 		var offset = $(this).scrollTop();

// 		if (offset >= tableOffset && $fixedHeader.is(":hidden")) {
// 			$fixedHeader.show();
// 		}
// 		else if (offset < tableOffset) {
// 			$fixedHeader.hide();
// 		}
// 		if(offset >= $('.js-to-product').offset().top) {
// 			$fixedHeader.hide();
// 		}
// 	});
// }

if( $(".table-wrapper.jquery-horizontal-scroll").length > 0 ) {
	var tableOffset = $(".table-wrapper.jquery-horizontal-scroll").offset().top;
	var tableHeight = $(".table-wrapper.jquery-horizontal-scroll th").height();
	var endTrigger = $('.js-to-product').offset().top;

	$(window).on("scroll", function() {
		var offset = $(this).scrollTop();
		if ($(window).width() > 768){
			var translateArrows = offset - 200;
			var translateTable = offset - 150;
		} else {
			var translateArrows = offset - 200;
			var translateTable = offset - 100;
		}



		if (offset >= tableOffset && offset < endTrigger - tableOffset) {
			$(".table-wrapper.jquery-horizontal-scroll thead").addClass('sticky');
			$(".table-wrapper.jquery-horizontal-scroll thead th").css('transform', 'translateY(' + translateTable + 'px)');
			$(".table-arrow").css('transform','translateY(' + translateArrows + 'px)');

		} else {

			$(".table-wrapper.jquery-horizontal-scroll thead").removeClass('sticky');
			$(".table-wrapper.jquery-horizontal-scroll thead th").css('transform', 'translateY(0px)');

			$(".table-arrow").css('transform','translateY(0px)');

		}
	});

}

// Filters

$(document).ready(function() {
  // Function to filter options based on the data-parent attribute
  function filterOptions($options, parentValue) {
    return $options.filter('[data-parent="' + parentValue + '"]');
  }

  const select2globalOptions = {
    theme: 'bootstrap-5',
    width: '300px',
  }

  const select2globalOptionsAttr = {
    theme: 'bootstrap-5',
    width: '300px',
    templateResult: function(data) {
      let $element = $('<span>' + data.id + '</span>');
      return $element;
    }
  }

  let initFilters = function() {
    let $filtersContainer = $('.filters-container');
    let $filterTemplate = $('.filters-group-template');
    let $filterClone = $filterTemplate.clone();

	// Prepare the filter clone
    $filterClone
	.removeClass('filters-group-template')
	.addClass('filters-group');

    $filterClone
	.find('span.select2')
	.remove();

	// Remove the select2 classes from the cloned select elements
    $filterClone
	.find('select')
	.removeClass('select2-hidden-accessible')
	.removeAttr('data-select2-id');

	// Append the cloned filter to the filters container
    $filtersContainer.append($filterClone);

	// Remove selected values from the main dropdown
	let mainOptionsSelected = $('.selected-values-container.main .selected-label');
	mainOptionsSelected.each(function() {
		let $value = $(this).data('value');
		// console.log('Value: ' + $value);
		$filterClone.find('.group-filter').find('option[value="' + $value + '"]').remove();
	});

	// Remove selected values from the attributes dropdown
	let attributesOptionsSelected = $('.selected-values-container.attributes .selected-label');
	attributesOptionsSelected.each(function() {
		let $value = $(this).data('value');
		// console.log('Value: ' + $value);
		$filterClone.find('.attributes-filter').find('option[value="' + $value + '"]').remove();
	});

  const select2globalOptionsCurrent = select2globalOptions;
  const firstselect2 = $filterClone.find(".group-filter").first();
  if (firstselect2) {
    select2globalOptionsCurrent.placeholder = firstselect2.data('pleaseselect');
    select2globalOptionsCurrent.placeholderForSearch = firstselect2.data('input');
  }
      // Initialize select2 for the main filter
    $filterClone.find(".group-filter").select2(select2globalOptionsCurrent);

	// Hide the attributes filter and the selected values container
    $filterClone.find('.filters-main-wrapper[data-group="attributes"]').hide();
    $filterClone.find('.selected-values-container .inner-container').hide();

	// Show the main filter
    $filtersContainer.fadeIn(300);

	// Filter the options based on the data-parent attribute of the selected option in the main filter
	let $options = $filterClone.find('.attributes-filter').find( 'option' );

	// Trigger the change event on the main filter and initialize the attributes select
    $filterClone.find(".group-filter").on( 'change', function() {
      let option = $(this).find(':selected');
      let parentValue = option.data('parent');
      let filteredOptions = filterOptions($options, parentValue);
      let emptyOption = $('<option selected=""></option>');


      const select2globalOptionsAttrCurrent = select2globalOptionsAttr;
      const firstselect2 = $filterClone.find(".attributes-filter").first();
      if (firstselect2) {
        select2globalOptionsAttrCurrent.placeholder = firstselect2.data('pleaseselect');
        select2globalOptionsAttrCurrent.placeholderForSearch = firstselect2.data('input');
      }

      $filterClone.find('.attributes-filter')
		  .html(filteredOptions)
		  .prepend(emptyOption)
      .select2(select2globalOptionsAttrCurrent);


		  $filterClone.find('.show-selector').removeClass('visible');
    } ).trigger( 'change' );
  }

  const reinitAttributesSelect = function($filtersWrapper) {
    let $mainFilterWrapper = $filtersWrapper.find('.filters-main-wrapper[data-group="main"]');
    let $attributesFilterWrapper = $filtersWrapper.find('.filters-main-wrapper[data-group="attributes"]');

    let $selectsTemplate = $('.filters-group-template');
    let $selectTemplateAttributes = $selectsTemplate.find('.filters-main-wrapper[data-group="attributes"] .select-filter');

    // Clone the select2 template
    $selectTemplateAttributes = $selectTemplateAttributes.clone();

    // Append the select2 template to the attributes filter container after the selected values container
    $attributesFilterWrapper.find('.selected-values-container .inner-container .selected-label:last').after($selectTemplateAttributes);

    // Remove selected values from the attributes dropdown
    let attributesOptionsSelected = $('.selected-values-container.attributes .selected-label');
    attributesOptionsSelected.each(function() {
      let $value = $(this).data('value');
      let escapedItemValue = $.escapeSelector($value);

      $attributesFilterWrapper.find('.attributes-filter').find('option[value="' + escapedItemValue + '"]').remove();
    });

    // Filter the select options based on the data-parent attribute of the selected option in the main filter
    $options = $attributesFilterWrapper.find('.attributes-filter').find( 'option' );

    let $filterGroupOption = $mainFilterWrapper.find(".selected-values-container .selected-label").last();
    let parentValue = $filterGroupOption.data('parent');
    let filteredOptions = filterOptions($options, parentValue);

    // Create an empty option element
    let emptyOption = $('<option selected=""></option>');


    // Prepend the empty option to the filtered options
    $attributesFilterWrapper.find('.attributes-filter')
    .html(filteredOptions)
    .prepend(emptyOption);

    // If select has more than one option, show the select
    if (filteredOptions.length > 0) {
      const select2globalOptionsAttrCurrent = select2globalOptionsAttr;
      const firstselect2 = $attributesFilterWrapper.find(".attributes-filter").first();
      if (firstselect2) {
        select2globalOptionsAttrCurrent.placeholder = firstselect2.data('pleaseselect');
        select2globalOptionsAttrCurrent.placeholderForSearch = firstselect2.data('input');
      }

      $attributesFilterWrapper.find('.attributes-filter').select2(select2globalOptionsAttrCurrent);
    }
  }

  $(document).on('click', '.remove-item', function() {
    let $selectedContainer = $(this).closest('.selected-values-container .inner-container');
    let $selectWrapper = $selectedContainer.closest('.filters-main-wrapper');
    let $type = $selectWrapper.data('group');
    let $label = $(this).parent();
    let $parentWrapper = $(this).parents('.filters-group');
    let $showButton = $selectWrapper.find('.show-selector');

    if ($type === 'attributes') {
      var escapedItemName = $.escapeSelector($label.data('name'));
      var escapedItemValue = $.escapeSelector($label.data('value') );

      $('.form-check-input[name$="' + escapedItemName + '"][value="' + escapedItemValue + '"]').prop('checked', false).trigger('change');
      $label.remove();
      if($selectWrapper.find('select').find('option').length > 1) {
        $showButton.removeClass('visible').addClass('hidden');
      } else {
        $showButton.removeClass('hidden').addClass('visible');
      }

    }

    if($type === 'main') {
      $selectedContainer.closest('.filters-main-wrapper[data-group="attributes"]').find('.attributes-filter').select2('destroy');
      let $labelsAttributes =  $parentWrapper.find('.filters-main-wrapper[data-group="attributes"]').find('.selected-label');
      $labelsAttributes.each(function() {
        $('.form-check-input[value="' + $(this).data('value') + '"]').prop('checked', false).trigger('change');
      });
      $selectWrapper.parent('.filters-group').remove();
      $('.add-filter').show();
    }

  });

  // click function for the show select with attributes
  $(document).on('click', '.show-selector', function() {
    // console.log('trigger click');
    let $currentWrapper = $(this).closest('.filters-group');
    $(this).removeClass('visible');
    reinitAttributesSelect($currentWrapper);
  });

  $(document).on('click', '.add-filter', function() {
    $(this).hide();
    initFilters();
  });

  $(document).on('click', '.toggle-filters', function() {
    $(this).toggleClass('active');
    $('.filters-wrapper').fadeToggle();
  });

  //When select2 is opened, close others select2
  $('select[name="select1"], select[name="select2"]').on('select2:open', function(e) {
    $('.select2-container--open').not(e.target).select2('close');
  });

  $(document).on('change', 'select[name="select1"], select[name="select2"]', function() {
	const $select = $(this);
	let $currentWrapper = $select.closest('.filters-group');
	let $selectWrapper = '';

	if($select.hasClass('group-filter')) {
		  $selectWrapper = $currentWrapper.find('.filters-main-wrapper[data-group="main"]');
      // console.log('Options: '  + $selectWrapper.find('option').length);
      if($selectWrapper.find('option').length > 1) {
          $('.add-filter').show();
      } else {
          $('.add-filter').hide();
      }
  } else {
    $selectWrapper = $currentWrapper.find('.filters-main-wrapper[data-group="attributes"]');
  }

  let $selectedContainer = $selectWrapper.find('.selected-values-container .inner-container');
  let $showButton = $selectWrapper.find('.show-selector');
  let $selectedOption = $select.find('option:selected');

  // Show the plus button to choose another attribute
  $selectedContainer.hide();

  let $itemParent = $selectedOption.data('parent');
  let $itemValue = $select.val();
  let $itemText = $selectedOption.html();
  let $itemName = $selectedOption.data('name');

  if($itemValue) {
    $currentWrapper.find('.filters-main-wrapper[data-group="attributes"]').show();
    $selectedContainer.show();
    // Destroy after select current select2 instances
    $selectWrapper.find('select').select2('destroy');
    $selectWrapper.find('.select-filter').remove();

    if($select.hasClass('attributes-filter')) {
      var escapedItemName = $.escapeSelector($itemName);
      var escapedItemValue = $.escapeSelector($itemValue);

      $('.form-check-input[name$="' + escapedItemName + '"][value="' + escapedItemValue + '"]').prop('checked', true).trigger('change');

      // console.log($itemName);
      $selectedContainer.find('.show-selector').before(`
        <div class="selected-label" data-value='${$itemValue}' data-name='${$itemName}' data-parent="${$itemParent}">
          <span class="selected-item">${$itemText}</span>
          <span class="remove-item" style="cursor: pointer; margin-left: 10px;">&#10006;</span>
        </div>
        `);

    } else {
      $selectedContainer.append(`
        <div class="selected-label" data-value='${$itemValue}' data-name="${$itemName}" data-parent="${$itemParent}">
          <span class="selected-item">${$itemText}</span>
          <span class="remove-item" style="cursor: pointer; margin-left: 10px;">&#10006;</span>
        </div>
        `);
    }

    if($select.hasClass('attributes-filter')) {
      // console.log('SelectHTML', $select.html());
      const $options = $select.find('option');
      const $optionsLength = $options.length;
      // console.log('Options Length', $optionsLength);

      if ($optionsLength - 2 <= 0) {
        $showButton.removeClass('visible').addClass('hidden');
      } else {
        $showButton.addClass('visible').removeClass('hidden');
      }
      // console.log('Options: '  + $selectWrapper.find('option').length);
      // $showButton.addClass('visible');
    }
  }
  });

  //End of filters

  // Handle Sorting dropdown
  $(document).on('change', '#hazet-sort-search-results', function() {
    let $targetSelector = $('.productlist-orderby');
    const $selectedValue = $(this).val();

    $targetSelector.find('.dropdown-item[value="' + $selectedValue + '"]').trigger('click');
  });

  // End Handle sorting dropdown

  $(document).on('click, focus, input', '.search-autocomplete-disable', function(e) {
      e.preventDefault();
      e.stopPropagation();
  });

  // Tracking
  $('.btn-open-drawerconfigurator').click(() => {
    if (typeof _mtm !== 'undefined') {
      _mtm.push({event: 'configurator-open-drawerconfigurator'});
    }
  });
  $('.btn-open-foamconfigurator').click(() => {
    if (typeof _mtm !== 'undefined') {
      _mtm.push({event: 'configurator-open-foamconfigurator'});
    }
  });
});
